// extracted by mini-css-extract-plugin
export default {"descriptionToggleButton":"X9-z"};